<template>
  <b-overlay
    :show="formShow"
    rounded="true"
    no-fade
    style="height:100vh!important"
    class="mb-5"
  >
    <b-card :aria-hidden="formShow ? 'true' : null">
      <b-row>
        <table class="table">
          <tr>
            <th
              scope="col"
              class="bg-primary text-white align-middle"
              style="font-size: 1.2em;"
            >
              REVIEW PREVIEW
            </th>
            <th
              scope="col"
              class="bg-primary text-white d-flex justify-content-end align-middle"
            >
              <b-button
                variant="secondary"
                class="animate__animated animate__fadeIn mr-1"
                style="background-color:white;color:#003b49"
                size="sm"
                @click="downloadEmptyForm()"
              >
                <feather-icon icon="DownloadIcon" size="14" class="mr-1" />
                Download Empty Form
              </b-button>
              <b-button
                variant="secondary"
                class="animate__animated animate__fadeIn mr-1"
                style="background-color:white;color:#003b49"
                size="sm"
                @click="downloadNewForm()"
              >
                <feather-icon icon="DownloadIcon" size="14" class="mr-1" />
                Download Report
              </b-button>
              <b-button
                variant="secondary"
                class="animate__animated animate__fadeIn mr-1"
                size="sm"
                @click="openFilesModal()"
              >
                <feather-icon icon="FileTextIcon" size="14" class="mr-1" />
                Files
              </b-button>
              <b-button @click="goBack" variant="secondary" size="sm">
                <feather-icon icon="ArrowLeftIcon" size="16" class="mr-50" />
                Back
              </b-button>
            </th>
          </tr>
        </table>
      </b-row>

      <div v-if="reviewData">
        <b-row class="mt-1">
          <!-- Person Selection (Read-only) -->
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Reviewee" label-for="person">
              <b-form-input
                id="person"
                type="text"
                :value="reviewData.firstName + ' ' + reviewData.lastName"
                disabled
                readonly
              />
            </b-form-group>
          </b-col>

          <!-- First Name -->
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="First Name" label-for="firstName">
              <b-form-input
                id="firstName"
                type="text"
                :value="reviewData.firstName"
                disabled
                readonly
              />
            </b-form-group>
          </b-col>

          <!-- Last Name -->
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Last Name" label-for="lastName">
              <b-form-input
                id="lastName"
                type="text"
                :value="reviewData.lastName"
                disabled
                readonly
              />
            </b-form-group>
          </b-col>

          <!-- Email -->
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Email" label-for="email">
              <b-form-input
                id="email"
                type="text"
                :value="reviewData.emailAdress"
                disabled
                readonly
              />
            </b-form-group>
          </b-col>

          <!-- Questionnaire -->
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Questionnaire" label-for="questionnaire">
              <b-form-input
                id="questionnaire"
                type="text"
                :value="reviewData.event ? reviewData.event.title : 'N/A'"
                disabled
                readonly
              />
            </b-form-group>
          </b-col>

          <!-- Observer -->
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Reviewer" label-for="observer">
              <b-form-input
                id="observer"
                type="text"
                :value="reviewData.observer"
                disabled
                readonly
              />
            </b-form-group>
          </b-col>

          <!--  Review Date -->
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Review Date" label-for="surveyDate">
              <b-form-input
                id="surveyDate"
                type="text"
                :value="formatDate(reviewData.surveyDate)"
                disabled
                readonly
              />
            </b-form-group>
          </b-col>

          <!-- Status -->
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label="Status" label-for="status">
              <b-form-input
                id="status"
                type="text"
                :value="reviewData.status === 'C' ? 'Completed' : 'In Progress'"
                disabled
                readonly
              />
            </b-form-group>
          </b-col>

          <!-- Comments Section -->
        </b-row>

        <!-- Total Score & Summary Explanation Section -->
        <b-row class="mt-2" v-if="reviewData.event && reviewData.event.groups">
          <b-col cols="12" xl="12" md="12" style="margin-bottom: 0.5rem;">
            <div class="current-range-card-slim d-flex align-items-center">
              <!-- Sol taraf: Total Score -->
              <div class="total-score-section" v-if="!hideScores">
                <div class="score-label">Total Score</div>
                <div class="score-value">{{ calculatedTotalScore }}</div>
              </div>

              <!-- Sağ taraf: Explanation -->
              <div class="explanation-section flex-grow-1">
                <div class="explanation-text">
                  {{ currentRangeExplanation }}
                </div>
              </div>
            </div>
          </b-col>
        </b-row>

        <!-- Quality Review Questions and Answers -->
        <div v-if="reviewData.event && reviewData.event.groups" class="mt-2">
          <div
            v-for="(group, groupIndex) in orderedGroups"
            :key="group.id"
            class="group-section"
            :class="{ 'mt-4': groupIndex > 0 }"
          >
            <b-col cols="12" class="bodyRow" style="padding: 0.2rem 0;">
              <div
                class="d-flex justify-content-between align-items-center mb-3"
              >
                <h4
                  class="group-title mb-0"
                  style="color: #003b49; font-weight: 600; border-bottom: 2px solid #003b49; padding-bottom: 0.5rem; flex-grow: 1;"
                >
                  {{ group.groupName }}
                </h4>
                <div class="group-status-badges ml-3">
                  <b-badge
                    :variant="getGroupStatusVariant(group)"
                    class="group-status-badge mr-2"
                  >
                    {{ getGroupStatus(group) }}
                  </b-badge>
                  <div
                    class="group-score-info"
                    v-if="!hideScores"
                    style="text-align: right; line-height: 1.3; font-family: monospace;"
                  >
                    <small class="text-muted d-block">
                      Group Score&nbsp;&nbsp;&nbsp;:
                      {{ calculateGroupScore(group) }}/{{
                        calculateGroupMaxScore(group)
                      }}
                    </small>
                    <small v-if="group.score" class="text-muted d-block">
                      Passing Score : {{ group.score }}
                    </small>
                    <small v-else class="text-muted d-block">
                      Passing Score : N/A
                    </small>
                  </div>
                </div>
              </div>

              <b-table-simple
                fixed
                striped
                :outlined="true"
                :responsive="true"
                :bordered="true"
                class="animate__animated animate__fadeIn mb-4"
              >
                <b-thead>
                  <b-tr>
                    <b-th :style="hideScores && hideComments? 'width:75%' : 'width:50%'">Questions</b-th>
                    <b-th class="text-center" style="width:25%" v-if="!hideScores && !hideComments">Answer</b-th>
                    <b-th class="text-center" style="width:25%">Status</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr
                    v-for="(question, questionIndex) in getOrderedQuestions(
                      group
                    )"
                    :key="questionIndex"
                    :class="getQuestionRowClass(question, group)"
                  >
                    <b-th class="text-left" style="font-weight: normal;">
                      <div class="question-content">
                        {{ question.title }}

                        <!-- Max Score ve Passing Score soru başlığının altında -->
                        <div
                          v-if="question.status === 'A' && !hideScores"
                          class="score-details mt-1 mb-1"
                          style="font-size: 0.85rem; color: #6c757d;"
                        >
                          <span v-if="question.maxScore">
                            ( Max Score: {{ question.maxScore }} )
                          </span>
                          <span
                            v-if="
                              question.passingScore !== null &&
                                question.passingScore !== undefined
                            "
                          >
                            ( Passing Score : {{ question.passingScore || 0 }} )
                          </span>
                        </div>

                        <div class="question-badges mt-1">
                          <b-badge
                            v-if="isCompulsoryQuestion(question)"
                            variant="warning"
                            class="compulsory-badge mr-2"
                          >
                            Compulsory
                          </b-badge>
                        </div>
                        <div
                          v-if="question.subtitle && question.status === 'A'"
                          class="mt-1"
                        >
                          <small class="text-muted" style="font-style: italic;">
                            {{ question.subtitle }}
                          </small>
                        </div>
                      </div>
                    </b-th>
                    <b-td
                      class="text-center"
                      :style="getAnswerStyle(question, group)"
                      v-if="!hideScores && !hideComments"
                    >
                      <span v-if="question.status === 'A' && hideScores" class="answer-display"></span>
                      <span v-else-if="question.status === 'B' && hideComments" class="answer-display"></span>
                      <span v-else class="answer-display">
                        {{ getQuestionAnswer(question.id) }}
                      </span>
                    </b-td>
                    <b-td class="text-center">
                      <div>
                        <div
                          v-if="
                            getQuestionStatus(question, group).includes('Failed') ||
                            getQuestionStatus(question, group).includes(getFailedStatus)
                          "
                        >
                          <small
                            class="font-weight-bold px-2 py-1"
                            style="font-style: italic; color: white; background-color: #d35400; border-radius: 4px; display: inline-block;"
                          >
                            {{ currentRangeExplanation || "FAILED" }}
                          </small>
                        </div>
                        <b-badge
                          v-else
                          :variant="getQuestionStatusVariant(question, group)"
                          class="question-status-badge"
                        >
                          {{ getQuestionStatus(question, group) }}
                        </b-badge>
                      </div>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col>
          </div>
          <div class="group-section" v-if="!hideComments">
            <b-col cols="12" class="bodyRow" style="padding: 0.2rem 0;">
              <div
                class="d-flex justify-content-between align-items-center mb-3"
              >
                <h4
                  class="group-title mb-0"
                  style="color: #003b49; font-weight: 600; border-bottom: 2px solid #003b49; padding-bottom: 0.5rem; flex-grow: 1;"
                >
                  General Comment
                </h4>
              </div>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Comment" label-for="comment">
                <b-form-textarea
                  id="comment"
                  :value="reviewData.generalComment || 'No comments'"
                  disabled
                  readonly
                  rows="2"
                />
              </b-form-group>
            </b-col>
          </div>
        </div>
      </div>

      <div v-else class="text-center py-5">
        <feather-icon
          icon="AlertCircleIcon"
          size="48"
          class="text-muted mb-3"
        />
        <h5 class="text-muted">Quality Review not found</h5>
        <p class="text-muted">
          The requested quality review could not be loaded.
        </p>
      </div>
    </b-card>

    <template #overlay v-if="download">
      <div class="text-center">
        <b-icon icon="stopwatch" font-scale="3" animation="cylon"> </b-icon>
        <p id="cancel-label">
          <feather-icon icon="DownloadIcon" /> Report creating please wait...
        </p>
      </div>
    </template>

    <!-- Files Modal -->
    <b-modal id="files-modal" title="Questionnaire Files" size="lg" hide-footer>
      <b-overlay :show="loadingFiles">
        <b-table
          :items="questionnaireFiles"
          :fields="fileTableFields"
          responsive
          class="mb-0"
          show-empty
          empty-text="No files found"
        >
          <template #cell(name)="data">
            <a :href="data.item.url" target="_blank" class="text-primary">
              {{ data.item.original_name }}
            </a>
          </template>
          <template #cell(size)="data">
            {{ formatFileSize(data.item.size) }}
          </template>
          <template #cell(created_at)="data">
            {{ formatDate(data.item.created_at) }}
          </template>
        </b-table>
      </b-overlay>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BTabs,
  BTab,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BBadge,
  BOverlay,
  BIcon,
  BModal,
  BTable,
} from "bootstrap-vue";
import store from "@/store";
import reviewStoreModule from "./reviewStoreModule";
import moment from "moment";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import _ from "lodash";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BBadge,
    BOverlay,
    BIcon,
    FeatherIcon,
  },

  setup() {
    const REVIEW_APP_STORE_MODULE_NAME = "review";

    // Register module
    if (!store.hasModule(REVIEW_APP_STORE_MODULE_NAME))
      store.registerModule(REVIEW_APP_STORE_MODULE_NAME, reviewStoreModule);
  },

  data() {
    return {
      formShow: false,
      reviewData: null,
      surveyId: null,
      summaryRanges: [],
      // Used to force re-computation in some computed props (parity with EditReview)
      forceRecompute: 0,
      download: false,
      // Files Modal Data
      showFilesModal: false,
      loadingFiles: false,
      questionnaireFiles: [],
      fileTableFields: [
        { key: "name", label: "File Name", sortable: true },
        { key: "size", label: "Size", sortable: true },
        { key: "created_at", label: "Upload Date", sortable: true },
      ],
    };
  },

  computed: {
    // Visibility flags from backend
    hideScores() {
      const rd = this.reviewData || {};
      return Boolean(rd.hide_scores ?? rd.hideScores ?? false);
    },
    hideComments() {
      const rd = this.reviewData || {};
      return Boolean(rd.hide_comments ?? rd.hideComments ?? false);
    },
    orderedGroups() {
      if (
        !this.reviewData ||
        !this.reviewData.event ||
        !this.reviewData.event.groups
      ) {
        return [];
      }
      // Sort groups by order if available, otherwise maintain original order
      return [...this.reviewData.event.groups].sort((a, b) => {
        if (a.order && b.order) {
          return a.order - b.order;
        }
        return 0;
      });
    },

    // Calculate total score dynamically
    calculatedTotalScore() {
      if (!this.reviewData?.event?.groups) {
        return 0;
      }

      let totalScore = 0;
      this.reviewData.event.groups.forEach((group) => {
        group.questions.forEach((question) => {
          if (
            question &&
            question.status === "A" &&
            question.commentAnswer !== "Not Observed" &&
            question.commentAnswer !== undefined &&
            question.commentAnswer !== null &&
            question.commentAnswer !== "" &&
            !isNaN(question.commentAnswer)
          ) {
            totalScore += Number(question.commentAnswer);
          }
        });
      });

      return totalScore;
    },

    // Check if there are any failed questions
    hasFailedQuestions() {
      if (!this.reviewData?.event?.groups) {
        return false;
      }

      return this.reviewData.event.groups.some((group) =>
        group.questions.some((question) => {
          if (question.status !== "A") return false;

          const answer = question.commentAnswer;
          if (
            answer === "Not Observed" ||
            answer === "No answer" ||
            answer === null ||
            answer === undefined ||
            answer === ""
          ) {
            return false;
          }

          const score = parseFloat(answer);
          const passingScore = parseFloat(question.passingScore || 0);

          return (
            !isNaN(score) &&
            !isNaN(passingScore) &&
            passingScore > 0 &&
            score < passingScore
          );
        })
      );
    },

    // Check if any group status reflects a failure (parity with EditReview)
    anyGroupFailed() {
      // Force reactivity trigger
      this.forceRecompute;

      const groups =
        this.reviewData &&
        this.reviewData.event &&
        this.reviewData.event.groups
          ? this.reviewData.event.groups
          : [];

      const failedStatus = this.getFailedStatus;

      return groups.some((group) => {
        const status = this.getGroupStatus(group);
        return (
          typeof status === "string" &&
          (status.includes("Failed") ||
            (failedStatus && status.includes(failedStatus)))
        );
      });
    },

    // Get the explanation for current score range (parity with EditReview)
    currentRangeExplanation() {
      // Force reactivity trigger
      this.forceRecompute;

      let explanation = null;

      // If any group failed (or there are failed questions), use the lowest range explanation
      if ((this.anyGroupFailed || this.hasFailedQuestions) && this.summaryRanges.length > 0) {
   
        explanation = this.summaryRanges[0].explanation.replace(/\[Score\]/g, "#totalScore#");
      } else {
        const currentRange = this.summaryRanges.find((range) =>
          this.isCurrentRange(range)
        );
        explanation = currentRange
          ? currentRange.explanation.replace(/\[Score\]/g, "#totalScore#")
          : null;
      }

      // Replace #totalScore# with actual calculated score, unless scores are hidden
      if (explanation && explanation.includes("#totalScore#")) {
        explanation = this.hideScores
          ? explanation.replace(/#totalScore#/g, "")
          : explanation.replace(/#totalScore#/g, this.calculatedTotalScore);
                  explanation = this.hideScores
          ? explanation.replace("-", "")
          : null;

      }

      return explanation;
    },

    // Derive the failed status text from the first summary range explanation
    getFailedStatus() {
      if (!this.summaryRanges || this.summaryRanges.length === 0) return "Failed";
      try {
        return this.summaryRanges[0].explanation.replace("- [Score]", "");
      } catch (e) {
        return "Failed";
      }
    },
  },

  created() {
    this.surveyId = this.$route.params.id;
    this.getReviewData();
  },

  methods: {
    getOrderedQuestions(group) {
      if (!group.questions) return [];
      // Sort questions by order field, fallback to original order
      return [...group.questions].sort((a, b) => {
        if (a.order && b.order) {
          return a.order - b.order;
        }
        return 0;
      });
    },

    isCompulsoryQuestion(question) {
      // A question is compulsory if max score equals passing score
      return (
        question.maxScore &&
        question.passingScore &&
        question.maxScore === question.passingScore
      );
    },

    calculateGroupScore(group) {
      if (!group.questions) return 0;

      let totalScore = 0;
      group.questions.forEach((question) => {
        // Sadece scoring questions (status 'A') için toplam hesapla
        if (question.status === "A") {
          const answer = this.getQuestionAnswer(question.id);
          if (
            answer !== "No answer" &&
            answer !== "Not Observed" &&
            !isNaN(answer)
          ) {
            totalScore += parseFloat(answer);
          }
        }
      });

      return totalScore.toFixed(1);
    },

    calculateGroupMaxScore(group) {
      if (!group.questions) return 0;

      let maxScore = 0;
      group.questions.forEach((question) => {
        // Sadece scoring questions (status 'A') için max score topla
        if (question.status === "A" && question.maxScore) {
          maxScore += question.maxScore;
        }
      });

      return maxScore;
    },

    getGroupStatus(group) {
      if (!group.questions || group.questions.length === 0) {
        return "No Questions";
      }

      const failedStatus = this.getFailedStatus;

      // Check for compulsory question failures first
      const hasCompulsoryFailure = group.questions.some((question) => {
        if (this.isCompulsoryQuestion(question)) {
          const answer = this.getQuestionAnswer(question.id);
          if (answer === "No answer" || answer === "Not Observed") {
            return true;
          }
          const score = parseFloat(answer);
          return !isNaN(score) && score < question.passingScore;
        }
        return false;
      });

      if (hasCompulsoryFailure) {
        return failedStatus + "(Compulsory)";
      }

      // Check group score requirement if exists
      if (group.score) {
        const currentGroupScore = parseFloat(this.calculateGroupScore(group));
        if (currentGroupScore < group.score) {
          return failedStatus + "(Group Score)";
        }
      }

      // Check individual question failures
      const failedQuestions = group.questions.filter((question) => {
        if (question.status === "B") return false; // Comment questions don't fail

        const answer = this.getQuestionAnswer(question.id);
        if (answer === "No answer" || answer === "Not Observed") {
          return false; // "Not Observed" is not considered a failure unless compulsory
        }

        const score = parseFloat(answer);
        return (
          !isNaN(score) &&
          question.passingScore &&
          score < question.passingScore
        );
      });

      if (failedQuestions.length > 0) {
        return failedStatus;
      }

      return "Passed";
    },

    getGroupStatusVariant(group) {
      const status = this.getGroupStatus(group);
      if (status.includes("Failed")) return "warning";
      if (status === "Passed") return "success";
      return "secondary";
    },

    getQuestionStatus(question, group) {
      if (question.status === "B") {
        return "Comment";
      }
      const failedStatus = this.getFailedStatus;
      const answer = this.getQuestionAnswer(question.id);

      if (answer === "No answer") {
        return "No Answer";
      }

      if (answer === "Not Observed") {
        if (this.isCompulsoryQuestion(question)) {
          return failedStatus + "(Compulsory)";
        }
        return "Not Observed";
      }

      const score = parseFloat(answer);
      if (isNaN(score)) {
        return "Invalid Score";
      }

      if (question.passingScore && score < question.passingScore) {
        if (this.isCompulsoryQuestion(question)) {
          return failedStatus + "(Compulsory)";
        }
        return failedStatus;
      }

      // Eğer passing score 0 ise "Completed", değilse "Passed"
      if (question.passingScore === 0) {
        return "Completed";
      }

      return "Passed";
    },

    getQuestionStatusVariant(question, group) {
      const failedStatus = this.getFailedStatus;
      const status = this.getQuestionStatus(question, group);
      if (status.includes("Failed")) return "warning";
      if (status.includes(failedStatus)) return "warning";
      if (status === "Passed") return "success";
      if (status === "Completed") return "primary";
      if (status === "Comment") return "info";
      if (status === "Not Observed") return "secondary";
      return "secondary";
    },

    getQuestionRowClass(question, group) {
      const status = this.getQuestionStatus(question, group);
      if (status.includes("Failed")) {
        return "table-danger-row";
      }
      return "";
    },

    getReviewData() {
      this.formShow = true;

      store
        .dispatch("review/fetchReview", this.surveyId)
        .then((response) => {
          this.reviewData = response.data;

          // Sort groups and questions by order to maintain correct sequence
          if (
            this.reviewData &&
            this.reviewData.event &&
            this.reviewData.event.groups
          ) {
            this.reviewData.event.groups.forEach((group) => {
              if (group.questions) {
                group.questions = group.questions.sort((a, b) => {
                  if (a.order && b.order) {
                    return a.order - b.order;
                  }
                  return 0;
                });
              }
            });
          }

          // Fetch summary data if review ID is available
          if (this.reviewData && this.reviewData.id) {
            this.fetchSummaryData(this.reviewData.id);
          }
        })
        .catch((error) => {
          console.error("Error fetching review:", error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              icon: "AlertTriangleIcon",
              text: "Error loading quality review data",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.formShow = false;
        });
    },

    getQuestionAnswer(questionId) {
      if (!this.reviewData || !this.reviewData.questionAnswer)
        return "No answer";

      const answer = this.reviewData.questionAnswer.find(
        (qa) => qa.questionId === questionId
      );

      return answer ? answer.commentAnswer : "No answer";
    },

    getAnswerStyle(question, group) {
      const answer = this.getQuestionAnswer(question.id);
      const status = this.getQuestionStatus(question, group);
      const failedStatus = this.getFailedStatus;

      // Comment questions - light blue
      if (question.status === "B") {
        return "background-color:#E6F3FF; border-left: 3px solid #17a2b8;";
      }

      // Failed questions - light orange
      if (status.includes("Failed")) {
        return "background-color:#fff3cd; border-left: 3px solid #fd7e14; font-weight: 600;";
      }
      if (status.includes(failedStatus)) {
        return "background-color:#fff3cd; border-left: 3px solid #fd7e14; font-weight: 600;";
      }

      // Not Observed - light yellow
      if (answer === "Not Observed") {
        return "background-color:#fff3cd; border-left: 3px solid #ffc107;";
      }

      // No answer - light gray
      if (answer === "No answer") {
        return "background-color:#f8f9fa; border-left: 3px solid #6c757d;";
      }

      // Passed questions - light green
      if (status === "Passed") {
        return "background-color:#D9FFF7; border-left: 3px solid #28a745; font-weight: 500;";
      }

      // Completed questions - light blue
      if (status === "Completed") {
        return "background-color:#E3F2FD; border-left: 3px solid #007bff; font-weight: 500;";
      }

      return "background-color:#f8f9fa;";
    },

    // Check if the current total score falls within this range (parity with EditReview)
    isCurrentRange(range) {
      // Force reactivity trigger
      this.forceRecompute;

      const currentScore = this.calculatedTotalScore;

      if (range.maxScore === "+") {
        return currentScore >= range.minScore;
      } else {
        return currentScore >= range.minScore && currentScore <= range.maxScore;
      }
    },

    formatDate(date) {
      if (!date) return "N/A";
      // Try to parse the date - backend might send in MM-DD-YYYY format
      const parsedDate = moment(
        String(date),
        ["MM-DD-YYYY", "M-D-YYYY", "YYYY-MM-DD"],
        true
      );
      if (parsedDate.isValid()) {
        return parsedDate.format("DD/MM/YYYY hh:mm A");
      }
      // Fallback to default parsing if specific format fails
      return moment(date).format("DD/MM/YYYY hh:mm A");
    },

    goBack() {
      this.$router.go(-1);
    },

    fetchSummaryData(surveyId) {
      // Use the same endpoint as EditReview for consistency
      this.$http
        .get(`summaryReview/${surveyId}`)
        .then((response) => {
          if (response.data) {
            // Check if response has ranges and explanations
            if (response.data.ranges && response.data.explanations) {
              const summaryData = response.data;
              const ranges = summaryData.ranges;
              const explanations = summaryData.explanations;

              this.summaryRanges = explanations.map((explanation, index) => {
                const minScore = ranges[index] || 0;
                const maxScore = ranges[index + 1]
                  ? ranges[index + 1] - 1
                  : "+";

                return {
                  minScore: minScore,
                  maxScore: maxScore,
                  rangeText:
                    maxScore === "+"
                      ? `${minScore}+`
                      : `${minScore}-${maxScore}`,
                  explanation: explanation.title.replace(
                    /#totalScore#/g,
                    "[Score]"
                  ),
                };
              });
            } else if (
              response.data.title &&
              Array.isArray(response.data.title)
            ) {
              // Handle array format
              this.summaryRanges = response.data.title.map((item, index) => {
                return {
                  minScore: item.range || 0,
                  maxScore:
                    index < response.data.title.length - 1
                      ? response.data.title[index + 1].range - 1
                      : "+",
                  rangeText:
                    index < response.data.title.length - 1
                      ? `${item.range}-${response.data.title[index + 1].range -
                          1}`
                      : `${item.range}+`,
                  explanation: item.title.replace(/#totalScore#/g, "[Score]"),
                };
              });
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching summary data:", error);
        });
    },
    downloadEmptyForm() {
      if (
        !this.reviewData ||
        !this.reviewData.event ||
        !this.reviewData.event.groups
      ) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: "Review data not available",
            variant: "danger",
          },
        });
        return;
      }

      this.formShow = true;
      this.download = true;

      this.$store
        .dispatch("review/createEmptyFormPdf", {
          info: {
            eventName: this.reviewData.event.title,
          },
          groups: this.reviewData.event.groups,
        })
        .then((response) => {
          if (response.status == 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `Empty Form - ${this.reviewData.event.title}.pdf`
            );
            document.body.appendChild(link);
            link.click();
            this.download = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Successful",
                text: "✔️ Empty Form is created!",
                icon: "ThumbsUpIcon",
                variant: "success",
              },
            });
            this.formShow = false;
          } else {
            this.formShow = false;
          }
        })
        .catch((error) => {
          this.toastDownloadErrorMessage("Download");
          this.formShow = false;
        });
    },
    downloadNewForm() {
      if (
        !this.reviewData ||
        !this.reviewData.event ||
        !this.reviewData.event.groups
      ) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: "Review data not available",
            variant: "danger",
          },
        });
        return;
      }

      this.formShow = true;
      this.download = true;

      // Prepare data array similar to EditReview
      let reportArray = [];
      let emptyGroupQuestion = [];

      this.reviewData.event.groups.map((item, index) => {
        let testArray = [];
        item.questions.map((question) => {
          if (question.status == "A") {
            testArray.push(question);
          }
        });
        if (testArray.length == 0) {
          emptyGroupQuestion.push(index);
        }
        reportArray.push(testArray);
      });

      if (reportArray.length > 0) {
        reportArray = _.reject(reportArray, _.isEmpty);
      }
      if (emptyGroupQuestion.length > 0) {
        for (var i = emptyGroupQuestion.length - 1; i >= 0; i--)
          this.reviewData.event.groups.splice(emptyGroupQuestion[i], 1);
      }

      this.$store
        .dispatch("review/createNewFormPdf", {
          data: reportArray,
          info: {
            id: this.reviewData.id,
            eventName: this.reviewData.event.title,
            firstName: this.reviewData.firstName,
            lastName: this.reviewData.lastName,
            emailAdress: this.reviewData.emailAdress,
            observer: this.reviewData.observer,
            surveyDate: this.reviewData.surveyDate,
            generalComment: this.reviewData.generalComment,
          },
          groups: this.reviewData.event.groups,
        })
        .then((response) => {
          if (response.status == 200) {
            console.log(response)
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `${this.reviewData.event.title} - ${
                this.reviewData.surveyDate
              } - ${this.reviewData.firstName +
                " " +
                this.reviewData.lastName}.pdf`
            );
            document.body.appendChild(link);
            link.click();
            this.download = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Successful",
                text: "✔️ New Form is created!",
                icon: "ThumbsUpIcon",
                variant: "success",
              },
            });
            this.formShow = false;
          } else {
            this.formShow = false;
          }
        })
        .catch((error) => {
          this.toastDownloadErrorMessage("Download");
          this.formShow = false;
        });
    },
    toastDownloadErrorMessage(type) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: `${type} failed. Please try again.`,
          variant: "danger",
        },
      });
    },

    // Files Modal Methods
    openFilesModal() {
      this.showFilesModal = true;
      this.loadQuestionnaireFiles();
      this.$bvModal.show("files-modal");
    },

    loadQuestionnaireFiles() {
      if (!this.reviewData?.event?.id) return;

      this.loadingFiles = true;
      this.$http
        .get(`questionnaire-files/${this.reviewData.event.id}`)
        .then((response) => {
          this.questionnaireFiles = response.data || [];
        })
        .catch((error) => {
          console.error("Error loading questionnaire files:", error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Error",
              text: "Failed to load files. Please try again.",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.loadingFiles = false;
        });
    },

    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },
  },
};
</script>

<style lang="scss" scoped>
.left-align .nav-tabs .nav-link {
  justify-content: left !important;
}

.nav-pills .nav-link {
  margin-bottom: 7px;
  white-space: nowrap;
}

.border {
  border: 1px solid #dee2e6 !important;
}

.rounded {
  border-radius: 0.375rem !important;
}

/* Group Section Styling */
.group-section {
  border: 1px solid #e3e6f0;
  border-radius: 0.375rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease;
  }
}

.group-title {
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
  color: #003b49 !important;
  border-bottom: 2px solid #003b49;
  padding-bottom: 0.5rem;
  flex-grow: 1;
}

/* Status Badge Styling */
.group-status-badges {
  display: flex;
  align-items: center;
  gap: 0.75rem;

  .group-status-badge {
    font-size: 0.875rem;
    font-weight: 600;
    padding: 0.5rem 1rem;
    border-radius: 0.375rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .group-score-info {
    font-weight: 500;
    color: #6c757d;
    background-color: #f8f9fa;
    padding: 0.25rem 0.75rem;
    border-radius: 0.25rem;
    border: 1px solid #dee2e6;
  }
}

.question-status-badge {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  min-width: 80px;
  text-align: center;
}

.compulsory-badge {
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.25rem 0.5rem;
  background-color: #ffc107 !important;
  color: #212529 !important;
  border: 1px solid #e0a800;
  border-radius: 0.25rem;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

/* Question Content Styling */
.question-content {
  .question-badges {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
    margin-bottom: 0.25rem;
  }

  .score-info {
    background-color: #e9ecef;
    padding: 0.15rem 0.4rem;
    border-radius: 0.25rem;
    border: 1px solid #ced4da;

    small {
      font-weight: 500;
      color: #495057;
    }
  }
}

/* Answer Display Styling */
.answer-display {
  font-weight: 600;
  font-size: 0.95rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  display: inline-block;
  min-width: 60px;
  text-align: center;
}

/* Table Row Styling */
.table-danger-row {
  background-color: rgba(220, 53, 69, 0.1) !important;

  &:hover {
    background-color: rgba(220, 53, 69, 0.15) !important;
  }

  td,
  th {
    border-top-color: rgba(220, 53, 69, 0.2) !important;
  }
}

/* Table Enhancements */
.table-simple {
  th,
  td {
    vertical-align: middle;
    padding: 0.75rem 0.5rem;
  }

  th {
    background-color: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
    font-weight: 600;
    color: #495057;
  }

  tbody tr {
    transition: background-color 0.2s ease;

    &:hover {
      background-color: rgba(0, 123, 255, 0.04);
    }
  }
}

/* Badge Variants */
.badge-success {
  background: #28a745 !important;
  color: white !important;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);
}

.badge-danger {
  background: #dc3545 !important;
  color: white !important;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3);
}

.badge-warning {
  background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%) !important;
  color: #212529 !important;
  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.3);
}

.badge-info {
  background: #17a2b8 !important;
  color: white !important;
  box-shadow: 0 2px 4px rgba(23, 162, 184, 0.3);
}

.badge-secondary {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%) !important;
  color: white !important;
  box-shadow: 0 2px 4px rgba(108, 117, 125, 0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .group-section {
    padding: 1rem;
    margin-bottom: 1rem;
  }

  .group-title {
    font-size: 1.1rem;
  }

  .group-status-badges {
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;

    .group-status-badge {
      text-align: center;
    }
  }

  .question-content .question-badges {
    flex-wrap: wrap;
    gap: 0.25rem;
  }

  .table-simple {
    th,
    td {
      padding: 0.5rem 0.25rem;
      font-size: 0.875rem;
    }
  }
}

/* Animation */
.animate__animated.animate__fadeIn {
  --animate-delay: 0.2s;
}

/* Total Score Card Styling */
.current-range-card-slim {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border-radius: 8px;
  padding: 1rem 1.5rem;
  color: white;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
  min-height: 80px;
  gap: 2rem;

  .total-score-section {
    flex-shrink: 0;
    min-width: 150px;
    text-align: center;

    .score-label {
      font-size: 0.9rem;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.8);
      margin-bottom: 0.25rem;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .score-value {
      font-size: 2rem;
      font-weight: 700;
      color: white;
      line-height: 1;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  }

  .explanation-section {
    padding-left: 2rem;
    border-left: 2px solid rgba(255, 255, 255, 0.3);
    display: flex;
    align-items: center;

    .explanation-text {
      font-size: 1rem;
      line-height: 1.5;
      color: rgba(255, 255, 255, 0.95);
      font-weight: 500;
    }
  }
}

/* Status-specific styling */
.bg-light-success {
  background-color: rgba(40, 167, 69, 0.1) !important;
  color: #28a745 !important;
}

.bg-light-danger {
  background-color: rgba(220, 53, 69, 0.1) !important;
  color: #dc3545 !important;
}

.bg-light-warning {
  background-color: rgba(255, 193, 7, 0.1) !important;
  color: #856404 !important;
}

.bg-light-info {
  background-color: rgba(23, 162, 184, 0.1) !important;
  color: #17a2b8 !important;
}
</style>
